import { companyAnnualPage, type CompanyAnnual, type CompanyAnnualPage } from '@/services/accountService/companyAnnualService';
import { computeYearOfAssessment } from '@/utils/dataUtils';

export type CompanyAnnualCreateFlow = 'account' | 'audit';

const CONFLICT_MESSAGE = 'year of assessment has been create by another flow, please confirm!';

function normalizeFlow(flowName?: string | null, flowType?: number | null): CompanyAnnualCreateFlow | null {
    if (flowType === 2) return 'account';
    if (flowType === 1) return 'audit';
    const value = String(flowName || '').trim().toLowerCase();
    if (!value) return null;
    if (value === 'account + audit' || value === 'account+audit' || value === 'account') return 'account';
    if (value === 'audit' || value === 'audit flow') return 'audit';
    return null;
}

export async function validateCompanyAnnualCreateFlow(params: {
    companyId?: number | null;
    periodTo?: string | null;
    yearOfAssessment?: string | null;
    expectedFlow: CompanyAnnualCreateFlow;
}): Promise<string | null> {
    const companyId = Number(params.companyId || 0);
    if (!companyId) return null;
    const yearOfAssessment = params.yearOfAssessment || computeYearOfAssessment(params.periodTo);
    if (!yearOfAssessment) return null;

    const resp = await companyAnnualPage({
        pageNumber: 1,
        pageSize: 10000,
        pageType: 0,
        yearOfAssessment,
    });

    const conflict = ((resp?.list || []) as CompanyAnnualPage[]).find((item) => {
        if (Number(item.companyId || 0) !== companyId) return false;
        if ((item.yearOfAssessment || null) !== yearOfAssessment) return false;
        const existingFlow = normalizeFlow(item.flowName, item.flowType);
        return existingFlow != null && existingFlow !== params.expectedFlow;
    });

    return conflict ? CONFLICT_MESSAGE : null;
}

export async function validateCompanyAnnualFormCreateFlow(params: {
    form: CompanyAnnual;
    expectedFlow: CompanyAnnualCreateFlow;
}): Promise<string | null> {
    return validateCompanyAnnualCreateFlow({
        companyId: params.form.companyId,
        periodTo: params.form.periodTo,
        yearOfAssessment: params.form.yearOfAssessment,
        expectedFlow: params.expectedFlow,
    });
}

export const COMPANY_ANNUAL_FLOW_CONFLICT_MESSAGE = CONFLICT_MESSAGE;
